module.exports = __webpack_public_path__ + "static/media/comingSoonRound.8b2de5f6.jpeg";